(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ─── Comparison Slider Instance ─────────────────────────────────────────── */
  function initComp(comp) {
    if (comp.__ba_initialized) return;
    comp.__ba_initialized = true;

    var divider = comp.querySelector('[data-ba-divider]');
    if (!divider) return;

    var initialVal = parseFloat(comp.getAttribute('data-initial')) || 50;
    var currentPct = initialVal;
    var isDragging = false;

    function updatePos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      currentPct = pct;
      comp.style.setProperty('--ba-pos', pct + '%');
      comp.setAttribute('aria-valuenow', Math.round(pct));
      comp.setAttribute('aria-valuetext', Math.round(pct) + '% Before, ' + (100 - Math.round(pct)) + '% After');
    }

    function getPct(clientX) {
      var rect = comp.getBoundingClientRect();
      if (rect.width <= 0) return 50;
      var relX = clientX - rect.left;
      return (relX / rect.width) * 100;
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isDragging = true;
      comp.classList.add('is-dragging');
      if (comp.setPointerCapture) {
        try { comp.setPointerCapture(e.pointerId); } catch (err) {}
      }
      updatePos(getPct(e.clientX));
      e.stopPropagation();
      e.preventDefault();
    }

    function onPointerMove(e) {
      if (!isDragging) return;
      updatePos(getPct(e.clientX));
      e.stopPropagation();
      e.preventDefault();
    }

    function onPointerUp(e) {
      if (!isDragging) return;
      isDragging = false;
      comp.classList.remove('is-dragging');
      if (comp.releasePointerCapture) {
        try { comp.releasePointerCapture(e.pointerId); } catch (err) {}
      }
    }

    // Keyboard support
    function onKeyDown(e) {
      var step = e.shiftKey ? 10 : 3;
      if (e.key === 'ArrowLeft') {
        updatePos(currentPct - step);
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        updatePos(currentPct + step);
        e.preventDefault();
      } else if (e.key === 'Home') {
        updatePos(0);
        e.preventDefault();
      } else if (e.key === 'End') {
        updatePos(100);
        e.preventDefault();
      }
    }

    comp.addEventListener('pointerdown', onPointerDown);
    comp.addEventListener('pointermove', onPointerMove);
    comp.addEventListener('pointerup', onPointerUp);
    comp.addEventListener('pointercancel', onPointerUp);
    comp.addEventListener('keydown', onKeyDown);

    // Initial render
    updatePos(initialVal);
  }

  /* ─── Carousel Instance ─────────────────────────────────────────────────── */
  function initCarousel(root) {
    if (root.__ba_carousel_initialized) return;
    root.__ba_carousel_initialized = true;

    var track = root.querySelector('[data-ba-track]');
    var slides = Array.from(root.querySelectorAll('[data-ba-slide]'));
    var prevBtn = root.querySelector('[data-ba-prev]');
    var nextBtn = root.querySelector('[data-ba-next]');
    var dots = Array.from(root.querySelectorAll('[data-ba-dot]'));
    var counterCurrent = root.querySelector('[data-ba-current]');

    if (!track || slides.length <= 1) return;

    var current = 0;
    var total = slides.length;

    function goTo(index) {
      current = Math.max(0, Math.min(total - 1, index));
      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      slides.forEach(function (s, i) {
        s.setAttribute('aria-hidden', i !== current ? 'true' : 'false');
      });

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });

      if (counterCurrent) {
        counterCurrent.textContent = current + 1;
      }

      if (prevBtn) prevBtn.disabled = (current === 0);
      if (nextBtn) nextBtn.disabled = (current === total - 1);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goTo(current - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goTo(current + 1); });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-ba-dot'), 10);
        goTo(idx);
      });
    });

    goTo(0);
  }

  /* ─── Initialization Bootstrap ─────────────────────────────────────────── */
  function initSection(sectionEl) {
    if (!sectionEl) return;
    var comps = sectionEl.querySelectorAll('[data-ba-comp]');
    comps.forEach(initComp);
    initCarousel(sectionEl);
  }

  function boot() {
    var sections = document.querySelectorAll('[data-section-id][id^="pl-ba-"]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editor dynamic events
  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target;
    var baRoot = target.querySelector('[data-section-id][id^="pl-ba-"]') || (target.matches('[id^="pl-ba-"]') ? target : null);
    if (baRoot) initSection(baRoot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ─── Comparison Slider Instance ─────────────────────────────────────────── */
  function initComp(comp) {
    if (comp.__ba_initialized) return;
    comp.__ba_initialized = true;

    var divider = comp.querySelector('[data-ba-divider]');
    if (!divider) return;

    var initialVal = parseFloat(comp.getAttribute('data-initial')) || 50;
    var currentPct = initialVal;
    var isDragging = false;

    function updatePos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      currentPct = pct;
      comp.style.setProperty('--ba-pos', pct + '%');
      comp.setAttribute('aria-valuenow', Math.round(pct));
      comp.setAttribute('aria-valuetext', Math.round(pct) + '% Before, ' + (100 - Math.round(pct)) + '% After');
    }

    function getPct(clientX) {
      var rect = comp.getBoundingClientRect();
      if (rect.width <= 0) return 50;
      var relX = clientX - rect.left;
      return (relX / rect.width) * 100;
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isDragging = true;
      comp.classList.add('is-dragging');
      if (comp.setPointerCapture) {
        try { comp.setPointerCapture(e.pointerId); } catch (err) {}
      }
      updatePos(getPct(e.clientX));
      e.stopPropagation();
      e.preventDefault();
    }

    function onPointerMove(e) {
      if (!isDragging) return;
      updatePos(getPct(e.clientX));
      e.stopPropagation();
      e.preventDefault();
    }

    function onPointerUp(e) {
      if (!isDragging) return;
      isDragging = false;
      comp.classList.remove('is-dragging');
      if (comp.releasePointerCapture) {
        try { comp.releasePointerCapture(e.pointerId); } catch (err) {}
      }
    }

    // Keyboard support
    function onKeyDown(e) {
      var step = e.shiftKey ? 10 : 3;
      if (e.key === 'ArrowLeft') {
        updatePos(currentPct - step);
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        updatePos(currentPct + step);
        e.preventDefault();
      } else if (e.key === 'Home') {
        updatePos(0);
        e.preventDefault();
      } else if (e.key === 'End') {
        updatePos(100);
        e.preventDefault();
      }
    }

    comp.addEventListener('pointerdown', onPointerDown);
    comp.addEventListener('pointermove', onPointerMove);
    comp.addEventListener('pointerup', onPointerUp);
    comp.addEventListener('pointercancel', onPointerUp);
    comp.addEventListener('keydown', onKeyDown);

    // Initial render
    updatePos(initialVal);
  }

  /* ─── Carousel Instance ─────────────────────────────────────────────────── */
  function initCarousel(root) {
    if (root.__ba_carousel_initialized) return;
    root.__ba_carousel_initialized = true;

    var track = root.querySelector('[data-ba-track]');
    var slides = Array.from(root.querySelectorAll('[data-ba-slide]'));
    var prevBtn = root.querySelector('[data-ba-prev]');
    var nextBtn = root.querySelector('[data-ba-next]');
    var dots = Array.from(root.querySelectorAll('[data-ba-dot]'));
    var counterCurrent = root.querySelector('[data-ba-current]');

    if (!track || slides.length <= 1) return;

    var current = 0;
    var total = slides.length;

    function goTo(index) {
      current = Math.max(0, Math.min(total - 1, index));
      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      slides.forEach(function (s, i) {
        s.setAttribute('aria-hidden', i !== current ? 'true' : 'false');
      });

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });

      if (counterCurrent) {
        counterCurrent.textContent = current + 1;
      }

      if (prevBtn) prevBtn.disabled = (current === 0);
      if (nextBtn) nextBtn.disabled = (current === total - 1);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goTo(current - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goTo(current + 1); });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-ba-dot'), 10);
        goTo(idx);
      });
    });

    goTo(0);
  }

  /* ─── Initialization Bootstrap ─────────────────────────────────────────── */
  function initSection(sectionEl) {
    if (!sectionEl) return;
    var comps = sectionEl.querySelectorAll('[data-ba-comp]');
    comps.forEach(initComp);
    initCarousel(sectionEl);
  }

  function boot() {
    var sections = document.querySelectorAll('[data-section-id][id^="pl-ba-"]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editor dynamic events
  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target;
    var baRoot = target.querySelector('[data-section-id][id^="pl-ba-"]') || (target.matches('[id^="pl-ba-"]') ? target : null);
    if (baRoot) initSection(baRoot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initComp(comp) {
    if (comp.__results_ba_init) return;
    comp.__results_ba_init = true;

    var initialVal = parseFloat(comp.getAttribute('data-initial')) || 50;
    var currentPct = initialVal;
    var isDragging = false;

    function updatePos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      currentPct = pct;
      comp.style.setProperty('--ba-pos', pct + '%');
      comp.setAttribute('aria-valuenow', Math.round(pct));
      comp.setAttribute('aria-valuetext', Math.round(pct) + '% Before, ' + (100 - Math.round(pct)) + '% After');
    }

    function getPct(clientX) {
      var rect = comp.getBoundingClientRect();
      if (rect.width <= 0) return 50;
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isDragging = true;
      comp.classList.add('is-dragging');
      if (comp.setPointerCapture) {
        try { comp.setPointerCapture(e.pointerId); } catch (err) {}
      }
      updatePos(getPct(e.clientX));
      e.stopPropagation();
      e.preventDefault();
    }

    function onPointerMove(e) {
      if (!isDragging) return;
      updatePos(getPct(e.clientX));
      e.stopPropagation();
      e.preventDefault();
    }

    function onPointerUp(e) {
      if (!isDragging) return;
      isDragging = false;
      comp.classList.remove('is-dragging');
      if (comp.releasePointerCapture) {
        try { comp.releasePointerCapture(e.pointerId); } catch (err) {}
      }
    }

    function onKeyDown(e) {
      var step = e.shiftKey ? 10 : 3;
      if (e.key === 'ArrowLeft') {
        updatePos(currentPct - step);
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        updatePos(currentPct + step);
        e.preventDefault();
      } else if (e.key === 'Home') {
        updatePos(0);
        e.preventDefault();
      } else if (e.key === 'End') {
        updatePos(100);
        e.preventDefault();
      }
    }

    comp.addEventListener('pointerdown', onPointerDown);
    comp.addEventListener('pointermove', onPointerMove);
    comp.addEventListener('pointerup', onPointerUp);
    comp.addEventListener('pointercancel', onPointerUp);
    comp.addEventListener('keydown', onKeyDown);

    updatePos(initialVal);
  }

  function boot() {
    document.querySelectorAll('[data-results-comp]').forEach(initComp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target;
    var comp = target.querySelector('[data-results-comp]');
    if (comp) initComp(comp);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
